import React, { FC, useContext, useEffect } from 'react';
import { useIsMobile } from '@sravni/react-utils';
import { StepContext } from '../../../creator/step.context';
import { useFormContext } from 'react-hook-form';
import { FocusFieldWrapper, StepContainer, StepSubmitBlock } from '../common';
import { Rows, Row, Col } from '../../../../landing.common';
import {
    BirthdayField,
    BirthPlaceField,
    FullNameField,
    PassportDateField,
    PassportIssuedByField,
    PassportNumberField,
    UnitCodeField,
} from './fields';
import { FORM_FIELDS, FORM_STEPS } from '../../../../../constants';
import { DesktopSubmitView } from '../../components/form/components/desktop.submit';

export const PassportStepView: FC = React.memo(() => {
    const isMobile = useIsMobile();
    const { currentStep, currentStepConfig } = useContext(StepContext);

    const form = useFormContext();

    const {
        formState: { dirtyFields: _ },
        setFocus,
    } = form;

    useEffect(() => {
        if (FORM_STEPS.PASSPORT === currentStepConfig.stepName) {
            if (!isMobile) {
                try {
                    setFocus(FORM_FIELDS.FULL_NAME);
                } catch (e) {}
            }
        }
    }, [currentStep]);

    return (
        <StepContainer>
            <Rows gap="16">
                <Row gap="16" mobileGap="12">
                    <Col>
                        <FocusFieldWrapper name={FORM_FIELDS.FULL_NAME} field={<FullNameField />} />
                    </Col>
                </Row>
                <Row gap="16" mobileGap="12">
                    <Col md-4>
                        <FocusFieldWrapper name={FORM_FIELDS.BIRTHDAY} field={<BirthdayField />} />
                    </Col>
                    <Col md-4>
                        <FocusFieldWrapper name={FORM_FIELDS.BIRTH_PLACE} field={<BirthPlaceField />} />
                    </Col>
                </Row>
                <Row gap="16" mobileGap="12">
                    <Col md-4>
                        <FocusFieldWrapper name={FORM_FIELDS.PASSPORT_NUMBER} field={<PassportNumberField />} />
                    </Col>
                    <Col md-4>
                        <FocusFieldWrapper name={FORM_FIELDS.PASSPORT_DATE} field={<PassportDateField />} />
                    </Col>
                    <Col md-4>
                        <FocusFieldWrapper name={FORM_FIELDS.UNIT_CODE} field={<UnitCodeField />} />
                    </Col>
                </Row>
                <Row gap="16" mobileGap="12">
                    <Col>
                        <FocusFieldWrapper name={FORM_FIELDS.ISSUED} field={<PassportIssuedByField />} />
                    </Col>
                </Row>
            </Rows>
            <StepSubmitBlock>
                <DesktopSubmitView />
            </StepSubmitBlock>
        </StepContainer>
    );
});

PassportStepView.displayName = 'PassportStepView';
